<script>
import { routeIsSettings, routerIsPatientAgendaSearch, routerIsPatientAgendaSchedulings } from '@/helpers/routes'
import LOGIN_TO_PROFESSIONAL from '@/plugins/http/professional'
import REGISTER_TO_PROFESSIONAL from '@/plugins/http/professional-register'

export default {
  name: 'top-menu-professional',
  data () {
    return {
      LOGIN_TO_PROFESSIONAL: LOGIN_TO_PROFESSIONAL,
      REGISTER_TO_PROFESSIONAL: REGISTER_TO_PROFESSIONAL
    }
  },
  computed: {
    routeIsSettings () {
      return routeIsSettings(this.$route)
    },
    routerIsPatientAgendaSearch () {
      return routerIsPatientAgendaSearch(this.$route)
    },
    routerIsPatientAgendaSchedulings () {
      return routerIsPatientAgendaSchedulings(this.$router)
    }
  },
  methods: {
    goToLoginProfessional () {
      location.href = this.LOGIN_TO_PROFESSIONAL
    },
    goToRegisterProfessional () {
      location.href = this.REGISTER_TO_PROFESSIONAL
    }
  }
}
</script>

<template lang="pug">
  div
    #switch-page.container-fluid.switch-page-paciente
      .container
        router-link.pull-right.transition(:to="{ name: 'patient.loading-page.index'}")
          strong(style="color: #fff")  Acesse a Área do Paciente
    #menu-wrapper.container-fluid
      .container
        #logo.col-sm-3.col-md-2
          router-link(:to="{ name: 'patient.loading-page.index'}")
           img(src='/static/images/logo.svg', width='164', height='50')
        ul#menu.col-sm-8.col-md-10
          a(href='', v-scroll-to="'#apresentacao-professonal'")
            li.apresentacao Apresentação
          a(href='', v-scroll-to="'#contato-professional'")
            li.contato Contato
          a#login.pull-right.m-left-5(@click.prevent="goToRegisterProfessional()")
              | Cadastro
              span.icon 
          a#login.pull-right(@click.prevent="goToLoginProfessional()")
            | Entrar
            span.icon 
</template>
<style scoped>
  #menu-wrapper #login {
    color: #ffffff;
    background: #0c6bb5;
    border-radius: 50px;
    padding: 5px 15px 5px 25px;
    font-size: 16px;
    margin: 30px 3px;
    font-weight: 300;
    -webkit-transition: color ease .3s, padding ease .3s;
    transition: color ease .3s, padding ease .3s;
    cursor: pointer;
}
  /* Switch */

  #switch-page {
      background: #2080cd;
      overflow: hidden;
  }

  #switch-page a {
      color: #fff;
      font-size: 13px;
      font-weight: 300;
      padding: 3px 0px;
      margin: 5px 0px;
      position: relative;
      border-bottom: 1px solid #fff;
      text-decoration: none;
      -webkit-transition: border ease .3s;
      transition: border ease .3s;
  }

  #switch-page a:hover {
      border-bottom: 1px solid #fff;
  }
</style>



// WEBPACK FOOTER //
// src/layout/headers/topMenuProfessional.vue